import React, { useEffect, useRef, useState } from 'react';
import { deleteDataRequest, getDataRequest, putDataRequest } from '../../api/serviceMethods';
import { PRODUCTS_KNOWLEDGE_URL } from '../../api/URLs';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import { formatDateSecondary } from '../../utils/dateFormatUtils';
import MessageConfirmModal from '../../components/messageModal/MessageConfirmModal';
import TableListProductKnowledge from './TableListProductKnowledge';
import ProductKnowledgeHeader from './ProductKnowledgeHeader';
import ProductKnowledgeMobileViewModal from '../../components/productKnowledge/ProductKnowledgeMobileViewModal';

const ProductKnowledgePage = () => {
  const [viewType, setViewType] = useState('table');
  const messageModalRef = useRef('');
  const [isListView, setIsListView] = useState(true);
  const [dates, setDates] = useState([null, null]);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    sortField: 'createdAt',
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [keyword, setkeyword] = useState('');
  let dataSource = data ? data : [];
  const { t } = useTranslation();

  const getDataRequestAll = async (value) => {
    setLoading(true);
    await getDataRequest(`${PRODUCTS_KNOWLEDGE_URL}`, {
      pageNo: tableParams.pagination.current,
      pageSize: tableParams.pagination.pageSize,
      keyword: value ? value.trim() : '',
      startDate: dates[0] ? formatDateSecondary(dates[0]) : '',
      endDate: dates[1] ? formatDateSecondary(dates[1]) : '',
      sortKeys: { [tableParams.sortField]: tableParams.sortOrder === 'ascend' ? 'asc' : 'desc' },
    })
      .then((res) => {
        if (res.status === 200) {
          let datas = res?.data
            ? res?.data.map((it) => ({
                ...it,
                productKnowledgeId: it.productKnowledgeId || it.id || it._id,
                key: it.productKnowledgeId || it.id || it._id,
                cover: it.coverimage?.url || (typeof it.coverimage === 'string' ? it.coverimage : ''),
                category: it.category,
                releaseTime: it.expiryAt ? it.expiryAt : '',
                account: it.createdBy?.name || it.createdBy || '',
                active: it.isActive,
              }))
            : [];
          setData(datas);
        }
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: res?.total || res?.data?.length || 0,
          },
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log('Error', err);
      });
  };

  const [isSearch, setIsSearch] = useState(true);
  useEffect(() => {
    isSearch && getDataRequestAll(keyword);
  }, [
    tableParams.pagination?.current,
    tableParams.pagination?.pageSize,
    tableParams?.sortOrder,
    tableParams?.sortField,
    JSON.stringify(tableParams.filters),
    isSearch,
  ]);

  const handleStatus = async (item) => {
    const recordId = item.productKnowledgeId || item.id || item._id;
    try {
      setLoading(true);
      await putDataRequest(`${PRODUCTS_KNOWLEDGE_URL}/${recordId}`, { isActive: !item.active })
        .then((res) => {
          if (res.status === 200) {
            messageModalRef.current.showSuccessConfirmsAutoClose(
              res && t(res.message),
              () => {},
              '',
              true
            );
            getDataRequestAll('');
          } else {
            messageModalRef.current.showWarningConfirmsAutoClose(
              res && t(res.message),
              () => {},
              '',
              true
            );
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          messageModalRef.current.showWarningConfirmsAutoClose(
            (err && err.response && err.response.data && err.response.data.message) || 'Server Error!',
            () => {},
            '',
            true
          );
        });
    } catch (error) {
      setLoading(false);
      messageModalRef.current.showWarningConfirmsAutoClose(t('Server Error!'), () => {}, '', true);
    }
  };

  const handleDelete = async (item) => {
    const recordId = item.productKnowledgeId || item.id || item._id;
    messageModalRef.current.showWarningConfirm(
      t('Are you sure you want to delete this product knowledge?'),
      async () => {
        setLoading(true);
        await deleteDataRequest(`${PRODUCTS_KNOWLEDGE_URL}/${recordId}`)
          .then((res) => {
            messageModalRef.current.showSuccessConfirmsAutoClose(
              res && t(res.message),
              () => {},
              '',
              true
            );
            getDataRequestAll('');
            setLoading(false);
          })
          .catch((err) => {
            messageModalRef.current.showWarningConfirmsAutoClose(t('Server Error!'), () => {}, '', true);
            setLoading(false);
          });
      },
      '',
      true
    );
  };

  const [previewId, setPreviewId] = useState(false);
  const handleView = async (item) => {
    const recordId = item.productKnowledgeId || item.id || item._id;
    setPreviewId(recordId);
  };

  return (
    <div className="box-shadow h-100 w-100">
      <div className="w-100 h-100 overflow-auto">
        <div className="w-100">
          <Spin spinning={loading}>
            <div className="w-100 mt-3" style={{ padding: '0px 25px' }}>
              <ProductKnowledgeHeader
                viewType={viewType}
                setViewType={setViewType}
                isListView={isListView}
                setIsListView={setIsListView}
                dates={dates}
                setDates={setDates}
                keyword={keyword}
                setkeyword={setkeyword}
                tableParams={tableParams}
                setTableParams={setTableParams}
                getDataRequestAll={() => {
                  setIsSearch(false);
                  setTimeout(() => {
                    setIsSearch(true);
                  }, 100);
                }}
              />
              <TableListProductKnowledge
                dataSource={dataSource}
                viewType={viewType}
                setViewType={setViewType}
                tableParams={tableParams}
                setTableParams={setTableParams}
                getDataRequestAll={getDataRequestAll}
                handleStatus={handleStatus}
                handleDelete={handleDelete}
                handleView={handleView}
              />
            </div>
          </Spin>
        </div>
      </div>
      <ProductKnowledgeMobileViewModal
        productKnowledgeId={previewId}
        id={previewId}
        show={!!previewId}
        setShow={() => setPreviewId(false)}
      />
      <MessageConfirmModal textCentered ref={messageModalRef} />
    </div>
  );
};

export default ProductKnowledgePage;
